<svelte:options
  customElement={{
    tag: 'teo-dialogs',
    extend: extendWithStyles,
  }}
/>

<script lang="ts">
  import type { TeoCore } from '@/teoCore/TeoCore';
  import { TeoDialogs } from '@/ui/components/dialogs';
  import { TeoContextProvider } from '@/utils/teo-context';

  import { extendWithStyles } from './web-component-utils';

  let { teoCore }: { teoCore?: TeoCore } = $props();
</script>

<TeoContextProvider {teoCore}>
  <TeoDialogs />
</TeoContextProvider>
